import {getLayoutDefaultValue,getStyleDefaultValue,getTextDefaultValue} from "../../../utils/configuration/defaultSchema/schema.util";
import {COMPONENT_SCHEMA,EVENTS_SCHEMA} from '../../../utils/configuration/schema'

export const textAreaDefaultSchema = (data) => {
    const {componentName,componentId,isPage} = data; return {
        component: {
            [COMPONENT_SCHEMA.ID]: `${componentName}${componentId !== '' ? '_' : ''}${componentId}`,
            [COMPONENT_SCHEMA.COMPONENT_NAME]: `${componentName}`,
            [COMPONENT_SCHEMA.SOURCE]: '',
            [COMPONENT_SCHEMA.KEYPAD_TYPE]: 'text',
            [COMPONENT_SCHEMA.PLACEHOLDER]: 'Placeholder',
            [COMPONENT_SCHEMA.ENABLED]: true,
            [COMPONENT_SCHEMA.ROWS]: 4,
        },
        text: getTextDefaultValue(data),
        style: getStyleDefaultValue(data),
        layout: getLayoutDefaultValue(data),
        events: [
            EVENTS_SCHEMA.CHANGE,
            EVENTS_SCHEMA.KEY_UP,
            EVENTS_SCHEMA.KEY_DOWN,
        ]
    }
}